import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './company-tools-category.types';

export const companyToolsCategorySelectors = {
  ...generateResourceSelectors<types.ICompanyToolsCategory>((state) => state.resource.companyToolsCategory),
};
